import useSWR from "swr";
import { useCreateHeyLightAdminAxiosInstance } from "../../Auth/useCreateHeyLightAdminAxiosInstance.ts";
import {
  HeyLightOrderDTO,
  HeyLightOrderStatus,
} from "../../HeyLight/heyLightOrderDTO.ts";
import {
  OrdersListQuery,
  OrdersPage,
  toOrdersApiParams,
} from "../OrdersList/OrdersListQuery.ts";

export function useGetAllHeyLightOrders(
  query: OrdersListQuery<HeyLightOrderStatus>,
) {
  const { createAxiosInstance } = useCreateHeyLightAdminAxiosInstance();
  const params = toOrdersApiParams(query);
  const { data, error, isLoading, mutate } = useSWR(
    ["heylight", "/admin/orders", JSON.stringify(params)],
    async ([, url]) => {
      const { data } = await createAxiosInstance().get<
        OrdersPage<HeyLightOrderDTO>
      >(url, { params });
      return data;
    },
    { keepPreviousData: true },
  );

  return {
    orders: data?.orders ?? [],
    total: data?.total ?? 0,
    error,
    isLoading: isLoading && data === undefined,
    mutate,
  };
}
